export const deleteChangeHostText = {
  modalTilteText: 'Apakah kamu yakin ingin menghapus jadwal ini? ',
  modalDescriptionText: 'Tindakan ini tidak bisa dibatalkan, dan semua detail terkait akan hilang.',
  primaryButtonModalText: 'Hapus Sekarang',
  secondaryButtonModalText: 'Batal',
  successDeleteText: 'Jadwal berhasil terhapus!',
};
